// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3cNMl","row":"styles_row__1Vat0"};